import { render } from "./MenuLi.vue?vue&type=template&id=64808f6c&scoped=true"
import script from "./MenuLi.vue?vue&type=script&lang=js"
export * from "./MenuLi.vue?vue&type=script&lang=js"

import "./MenuLi.vue?vue&type=style&index=0&id=64808f6c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64808f6c"]])

export default __exports__